import React from "react";
import { RingLoader } from "react-spinners";

export const PageLoader = () => {
  return <RingLoader color="#6da9b3" size={240} />;
};
